import { ReactNode } from "react";
import {
  AddressMapProvider,
  useAddressMapContext,
} from "shared-ui/src/features/maps-feature/AddressMapProvider";
import { ShipmentMapProvider } from "shared-ui/src/features/maps-feature/ShipmentMapProvider";
import { AddressMap } from "shared-ui/src/features/storefront-feature";
import { useGetAddressMap } from "./hooks/useGetAddressMap";
import { useGetShipmentMap } from "./hooks/useGetShipmentMap";

interface CustomerExperienceAddressMapProviderProps {
  children: ReactNode;
  latitude?: number | null;
  longitude?: number | null;
  width?: number;
  height?: number;
}

interface CustomerExperienceShipmentMapProviderProps {
  children: ReactNode;
  biOrderId?: string | number | null;
  trackingNumber?: string | null;
  lastSeenLocation?: string | null;
  width?: number;
  height?: number;
}

function AddressMapContextConsumer() {
  const { data, isLoading, isError } = useAddressMapContext();
  return <AddressMap mapData={data} isLoading={isLoading} isError={isError} />;
}

export { AddressMapContextConsumer };

export function CustomerExperienceAddressMapProvider({
  children,
  latitude,
  longitude,
  width = 500,
  height = 200,
}: Readonly<CustomerExperienceAddressMapProviderProps>) {
  const { data, isLoading, isError, error } = useGetAddressMap({
    latitude,
    longitude,
    width,
    height,
  });

  return (
    <AddressMapProvider
      value={{ data, isLoading, isError, error: error || null }}
    >
      {children}
    </AddressMapProvider>
  );
}

export function CustomerExperienceShipmentMapProvider({
  children,
  biOrderId,
  trackingNumber,
  lastSeenLocation,
}: Readonly<CustomerExperienceShipmentMapProviderProps>) {
  const { data, isLoading, isError, error } = useGetShipmentMap({
    biOrderId,
    trackingNumber,
    lastSeenLocation,
  });

  return (
    <ShipmentMapProvider
      value={{ data, isLoading, isError, error: error || null }}
    >
      {children}
    </ShipmentMapProvider>
  );
}
